import { useEffect, useState } from "react";
import { api } from "./api";

let cachedRoles = null;
let inflight = null;
const listeners = new Set();

function notify(roles) {
  cachedRoles = roles;
  listeners.forEach((l) => l(roles));
}

export async function refreshRoles() {
  try {
    const r = await api.get("/admin/roles");
    notify(r.data);
    return r.data;
  } catch {
    return cachedRoles || [];
  }
}

export function useRoles() {
  const [roles, setRoles] = useState(() => cachedRoles || []);

  useEffect(() => {
    listeners.add(setRoles);
    if (!cachedRoles) {
      if (!inflight) inflight = refreshRoles().finally(() => { inflight = null; });
    }
    return () => listeners.delete(setRoles);
  }, []);

  return roles;
}

export function labelForRole(roleKey, roles) {
  const list = roles || cachedRoles || [];
  const found = list.find((r) => r.key === roleKey);
  return found?.label || roleKey;
}
